import { TooltipPosition } from './tooltip-position.type';

export interface PositionResult {
  top: number;
  left: number;
}

export function computeTooltipPosition(
  hostRect: DOMRect,
  tooltipRect: DOMRect,
  position: TooltipPosition,
  spacing = 10,
  margin = 8
): PositionResult {
  let top = 0;
  let left = 0;

  switch (position) {
    case 'top':
      top = hostRect.top - tooltipRect.height - spacing;
      left = hostRect.left + hostRect.width / 2 - tooltipRect.width / 2;
      break;
    case 'bottom':
      top = hostRect.bottom + spacing;
      left = hostRect.left + hostRect.width / 2 - tooltipRect.width / 2;
      break;
    case 'left':
      top = hostRect.top + hostRect.height / 2 - tooltipRect.height / 2;
      left = hostRect.left - tooltipRect.width - spacing;
      break;
    case 'right':
      top = hostRect.top + hostRect.height / 2 - tooltipRect.height / 2;
      left = hostRect.right + spacing;
      break;
  }

  const maxLeft = window.innerWidth - tooltipRect.width - margin;
  const maxTop = window.innerHeight - tooltipRect.height - margin;

  return {
    left: Math.max(margin, Math.min(left, maxLeft)),
    top: Math.max(margin, Math.min(top, maxTop)),
  };
}
